import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react';

// Define the context type
interface TaskContextType {
  selectedTaskId: string;
  setSelectedTaskId: (id: string) => void;
  hasNewPageTask: boolean;
  setHasNewPageTask: (visible: boolean) => void;
  addTaskClicked: boolean;
  setAddTaskClicked: (visible: boolean) => void;
}

// Create the context
const TaskContext = createContext<TaskContextType | undefined>(undefined);

// Define the provider props type
interface TaskProviderProps {
  children: ReactNode;
}

export const TaskProvider: React.FC<TaskProviderProps> = ({ children }) => {
  const [selectedTaskId, setSelectedTaskId] = useState('');
  const [hasNewPageTask, setHasNewPageTask] = useState(false);

  const [addTaskClicked, setAddTaskClicked] = useState(false);

  // Provide the state and updater functions to the context
  const value = useMemo(
    () => ({
      selectedTaskId,
      setSelectedTaskId,
      hasNewPageTask,
      setHasNewPageTask,
      addTaskClicked,
      setAddTaskClicked
    }),
    [selectedTaskId, setSelectedTaskId, hasNewPageTask, setHasNewPageTask, addTaskClicked, setAddTaskClicked]
  );

  return <TaskContext.Provider value={value}>{children}</TaskContext.Provider>;
};

export function useTaskContext() {
  const context = useContext(TaskContext);

  if (context === undefined) {
    throw new Error('useTaskContext must be used within a TaskProvider');
  }
  return context;
}
